export default __webpack_public_path__ + "static/media/Arugula.a53e5505.jpg";